import velocity from 'velocity-animate';
import Notifications from 'vue-notification';
import vuePersianFilters from 'vue-persian-filters';

const GlobalComponents = {
	// use packages
	install(Vue) {
		Vue.use(Notifications, { velocity });
		Vue.use(vuePersianFilters);
	},
};

export default GlobalComponents;
